import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-white dark:bg-[#0c1427]" }
const _hoisted_2 = { class: "sticky top-0 z-[5] backdrop-blur-xl bg-white/70 dark:bg-[#0c1427]/70" }
const _hoisted_3 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4" }
const _hoisted_4 = { class: "flex flex-col sm:flex-row items-center justify-between gap-4" }
const _hoisted_5 = { class: "w-full sm:w-auto" }
const _hoisted_6 = { class: "relative group" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" }
const _hoisted_10 = { class: "grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_11 = {
  class: "rounded-2xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1",
  style: {"background":"linear-gradient(135deg, #667eea 0%, #764ba2 100%)"}
}
const _hoisted_12 = { class: "flex items-center justify-between" }
const _hoisted_13 = { class: "text-white/80 text-sm font-medium mb-1" }
const _hoisted_14 = { class: "text-white text-3xl font-bold" }
const _hoisted_15 = {
  class: "rounded-2xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1",
  style: {"background":"linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"}
}
const _hoisted_16 = { class: "flex items-center justify-between" }
const _hoisted_17 = { class: "text-white/80 text-sm font-medium mb-1" }
const _hoisted_18 = { class: "text-white text-3xl font-bold" }
const _hoisted_19 = {
  class: "rounded-2xl p-6 shadow-lg transition-all duration-300 hover:shadow-xl hover:-translate-y-1",
  style: {"background":"linear-gradient(135deg, #fa709a 0%, #fee140 100%)"}
}
const _hoisted_20 = { class: "text-white text-sm font-medium mb-3" }
const _hoisted_21 = { class: "space-y-2" }
const _hoisted_22 = { class: "flex items-center justify-between" }
const _hoisted_23 = { class: "flex items-center gap-2" }
const _hoisted_24 = { class: "text-white/90 text-xs" }
const _hoisted_25 = { class: "text-white font-semibold text-sm" }
const _hoisted_26 = { class: "flex items-center justify-between" }
const _hoisted_27 = { class: "flex items-center gap-2" }
const _hoisted_28 = { class: "text-white/90 text-xs" }
const _hoisted_29 = { class: "text-white font-semibold text-sm" }
const _hoisted_30 = { class: "flex items-center justify-between" }
const _hoisted_31 = { class: "flex items-center gap-2" }
const _hoisted_32 = { class: "text-white/90 text-xs" }
const _hoisted_33 = { class: "text-white font-semibold text-sm" }
const _hoisted_34 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-6" }
const _hoisted_35 = {
  class: "rounded-2xl p-4 sm:p-6 shadow-lg dark:shadow-xl dark:!bg-[#15203c] dark:!border-[#2a3441]",
  style: {"background-color":"#ffffff","border":"1px solid #e5e7eb"}
}
const _hoisted_36 = { class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4" }
const _hoisted_37 = { class: "text-lg font-semibold text-gray-900 dark:text-white" }
const _hoisted_38 = { class: "flex flex-wrap items-center gap-3 w-full sm:w-auto" }
const _hoisted_39 = { class: "relative" }
const _hoisted_40 = { value: "all" }
const _hoisted_41 = { value: "overdue" }
const _hoisted_42 = { value: "today" }
const _hoisted_43 = { value: "tomorrow" }
const _hoisted_44 = { value: "thisWeek" }
const _hoisted_45 = { value: "nextWeek" }
const _hoisted_46 = { value: "thisMonth" }
const _hoisted_47 = { class: "relative" }
const _hoisted_48 = { value: "all" }
const _hoisted_49 = { value: "high" }
const _hoisted_50 = { value: "medium" }
const _hoisted_51 = { value: "low" }
const _hoisted_52 = { class: "relative" }
const _hoisted_53 = { value: "all" }
const _hoisted_54 = { value: "pending" }
const _hoisted_55 = { value: "in_progress" }
const _hoisted_56 = { value: "completed" }
const _hoisted_57 = { value: "cancelled" }
const _hoisted_58 = {
  key: 0,
  class: "mt-4 flex flex-wrap items-center gap-2"
}
const _hoisted_59 = { class: "text-sm font-medium text-gray-600 dark:text-gray-300" }
const _hoisted_60 = {
  key: 0,
  class: "inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium",
  style: {"background-color":"#ede9fe","color":"#7c3aed"}
}
const _hoisted_61 = {
  key: 1,
  class: "inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium",
  style: {"background-color":"#fef3c7","color":"#d97706"}
}
const _hoisted_62 = {
  key: 2,
  class: "inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium",
  style: {"background-color":"#dbeafe","color":"#2563eb"}
}
const _hoisted_63 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" }
const _hoisted_64 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-20"
}
const _hoisted_65 = { class: "mt-4 text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_66 = {
  key: 1,
  class: "text-center py-20"
}
const _hoisted_67 = { class: "text-sm text-danger-500" }
const _hoisted_68 = {
  key: 2,
  class: "text-center py-20"
}
const _hoisted_69 = { class: "text-sm text-gray-500 dark:text-gray-400" }
const _hoisted_70 = {
  key: 3,
  class: "grid gap-4 md:gap-6 md:grid-cols-2"
}
const _hoisted_71 = { class: "p-6" }
const _hoisted_72 = { class: "flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4" }
const _hoisted_73 = { class: "flex-1 min-w-0" }
const _hoisted_74 = { class: "flex items-start gap-3 mb-3" }
const _hoisted_75 = { class: "text-base sm:text-lg font-semibold text-black dark:text-white break-words" }
const _hoisted_76 = { class: "flex flex-wrap items-center gap-2 sm:gap-4 text-xs sm:text-sm" }
const _hoisted_77 = { class: "flex items-center gap-1 sm:gap-2" }
const _hoisted_78 = { class: "text-gray-500 dark:text-gray-400 truncate max-w-[120px] sm:max-w-none" }
const _hoisted_79 = { class: "flex items-center gap-1 sm:gap-2" }
const _hoisted_80 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_81 = { class: "flex items-center gap-1 sm:gap-2" }
const _hoisted_82 = { class: "text-gray-500 dark:text-gray-400" }
const _hoisted_83 = { class: "mt-3 sm:mt-4" }
const _hoisted_84 = { class: "flex items-center gap-2 mt-3 sm:mt-0 sm:opacity-0 sm:group-hover:opacity-100 transition-opacity duration-200" }
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["onClick"]
const _hoisted_87 = ["onClick"]
const _hoisted_88 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center md:items-center z-50 p-4 mobile-modal-container overflow-hidden"
}
const _hoisted_89 = { class: "relative w-full max-w-lg transform transition-all duration-300 scale-100 opacity-100 mobile-modal-content flex flex-col max-h-[85vh]" }
const _hoisted_90 = { class: "bg-white dark:bg-[#1c1c1e] rounded-3xl shadow-2xl overflow-hidden flex flex-col h-full" }
const _hoisted_91 = { class: "relative px-6 py-5 bg-gradient-to-r from-primary-500 to-primary-600 dark:from-primary-600 dark:to-primary-700 flex-shrink-0" }
const _hoisted_92 = {
  class: "flex items-center justify-between",
  style: {"display":"flex","align-items":"center","justify-content":"space-between"}
}
const _hoisted_93 = {
  class: "flex items-center gap-3",
  style: {"display":"flex","align-items":"center","gap":"12px"}
}
const _hoisted_94 = { class: "w-10 h-10 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center" }
const _hoisted_95 = { class: "material-symbols-outlined !text-[24px] text-white" }
const _hoisted_96 = {
  class: "text-xl font-bold text-white",
  style: {"margin":"0"}
}
const _hoisted_97 = { class: "px-6 py-6 space-y-5 overflow-y-auto custom-scrollbar flex-1" }
const _hoisted_98 = { class: "group" }
const _hoisted_99 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_100 = ["placeholder"]
const _hoisted_101 = { class: "group" }
const _hoisted_102 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_103 = { class: "group" }
const _hoisted_104 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_105 = { value: "" }
const _hoisted_106 = ["value"]
const _hoisted_107 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_108 = { class: "group" }
const _hoisted_109 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_110 = { class: "relative" }
const _hoisted_111 = { value: "high" }
const _hoisted_112 = { value: "medium" }
const _hoisted_113 = { value: "low" }
const _hoisted_114 = { class: "group" }
const _hoisted_115 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_116 = { class: "relative" }
const _hoisted_117 = { value: "pending" }
const _hoisted_118 = { value: "in_progress" }
const _hoisted_119 = { value: "completed" }
const _hoisted_120 = { value: "cancelled" }
const _hoisted_121 = { class: "group" }
const _hoisted_122 = { class: "flex items-center gap-2 text-sm font-semibold mb-2 text-gray-700 dark:text-gray-200" }
const _hoisted_123 = { class: "ml-auto text-xs font-normal text-gray-500 dark:text-gray-400" }
const _hoisted_124 = ["placeholder"]
const _hoisted_125 = { class: "px-6 py-4 bg-gray-50 dark:bg-[#15203c] border-t border-gray-200 dark:border-gray-800 flex justify-between gap-3 flex-shrink-0" }
const _hoisted_126 = ["disabled"]
const _hoisted_127 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_128 = {
  key: 1,
  class: "flex items-center gap-2"
}
const _hoisted_129 = { class: "material-symbols-outlined !text-[18px]" }
const _hoisted_130 = {
  key: 1,
  class: "fixed inset-0 flex items-center justify-center md:items-center z-50 p-4 mobile-modal-container overflow-hidden"
}
const _hoisted_131 = { class: "relative w-full max-w-lg transform transition-all duration-300 scale-100 opacity-100 mobile-modal-content flex flex-col max-h-[85vh]" }
const _hoisted_132 = { class: "bg-white dark:bg-[#1c1c1e] rounded-3xl shadow-2xl overflow-hidden flex flex-col h-full" }
const _hoisted_133 = {
  class: "flex items-center justify-between",
  style: {"display":"flex","align-items":"center","justify-content":"space-between"}
}
const _hoisted_134 = {
  class: "flex items-center gap-3",
  style: {"display":"flex","align-items":"center","gap":"12px"}
}
const _hoisted_135 = {
  class: "text-xl font-bold text-white",
  style: {"margin":"0"}
}
const _hoisted_136 = { class: "px-6 py-6 space-y-5 overflow-y-auto custom-scrollbar flex-1" }
const _hoisted_137 = { class: "space-y-2" }
const _hoisted_138 = { class: "flex items-center gap-2" }
const _hoisted_139 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_140 = { class: "text-xl font-bold text-black dark:text-white pl-7" }
const _hoisted_141 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_142 = { class: "bg-gray-50 dark:bg-[#2c2c2e] p-4 rounded-xl" }
const _hoisted_143 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_144 = { class: "text-xs font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_145 = { class: "text-sm font-semibold text-black dark:text-white" }
const _hoisted_146 = { class: "bg-gray-50 dark:bg-[#2c2c2e] p-4 rounded-xl" }
const _hoisted_147 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_148 = { class: "text-xs font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_149 = { class: "text-sm font-semibold text-black dark:text-white" }
const _hoisted_150 = { class: "bg-gray-50 dark:bg-[#2c2c2e] p-4 rounded-xl" }
const _hoisted_151 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_152 = { class: "text-xs font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_153 = { class: "flex items-center gap-2" }
const _hoisted_154 = { class: "text-sm font-semibold text-black dark:text-white" }
const _hoisted_155 = { class: "bg-gray-50 dark:bg-[#2c2c2e] p-4 rounded-xl" }
const _hoisted_156 = { class: "flex items-center gap-2 mb-2" }
const _hoisted_157 = { class: "text-xs font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_158 = {
  key: 0,
  class: "space-y-2"
}
const _hoisted_159 = { class: "flex items-center gap-2" }
const _hoisted_160 = { class: "text-sm font-medium text-gray-500 dark:text-gray-400" }
const _hoisted_161 = { class: "bg-gray-50 dark:bg-[#2c2c2e] p-4 rounded-xl" }
const _hoisted_162 = { class: "text-sm leading-relaxed text-black dark:text-white whitespace-pre-wrap" }
const _hoisted_163 = { class: "px-6 py-4 bg-gray-50 dark:bg-[#15203c] border-t border-gray-200 dark:border-gray-800 flex justify-between flex-shrink-0" }
const _hoisted_164 = { class: "flex items-center gap-2" }
const _hoisted_165 = {
  key: 2,
  class: "fixed inset-0 flex items-center justify-center md:items-center z-50 p-4 mobile-modal-container"
}
const _hoisted_166 = { class: "relative w-full max-w-md transform transition-all duration-300 scale-100 opacity-100 mobile-modal-content" }
const _hoisted_167 = { style: {"background":"linear-gradient(135deg, #ef4444 0%, #dc2626 100%)","padding":"24px"} }
const _hoisted_168 = {
  class: "flex items-center justify-between",
  style: {"display":"flex","align-items":"center","justify-content":"space-between"}
}
const _hoisted_169 = {
  class: "flex items-center gap-3",
  style: {"display":"flex","align-items":"center","gap":"12px"}
}
const _hoisted_170 = { style: {"font-size":"20px","font-weight":"700","color":"#ffffff","margin":"0"} }
const _hoisted_171 = { style: {"padding":"32px"} }
const _hoisted_172 = { style: {"text-align":"center","margin-bottom":"24px"} }
const _hoisted_173 = ["disabled"]
const _hoisted_174 = {
  key: 0,
  class: "animate-spin",
  style: {"width":"16px","height":"16px","border":"2px solid #ffffff","border-top-color":"transparent","border-radius":"50%"}
}
const _hoisted_175 = {
  key: 1,
  class: "flex items-center gap-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("label", {
                class: _normalizeClass(["absolute left-4 top-1/2 -translate-y-1/2 transition-all duration-300 pointer-events-none", _ctx.searchQuery ? 'opacity-0 -translate-x-2' : 'opacity-100'])
              }, _cache[40] || (_cache[40] = [
                _createElementVNode("i", {
                  class: "material-symbols-outlined !text-[22px]",
                  style: {"color":"#9ca3af"}
                }, "search", -1)
              ]), 2),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
                placeholder: _ctx.directT('todoList.searchTask'),
                class: _normalizeClass(["w-full sm:w-[380px] h-[48px] pl-12 pr-12 rounded-full border-2 transition-all duration-300 text-sm sm:text-base font-medium shadow-md hover:shadow-lg focus:shadow-xl outline-none placeholder:text-gray-400 dark:placeholder:text-gray-500", { 'dark:!bg-[#1a2332] dark:!text-white dark:!border-[#2a3441]': true }]),
                style: _normalizeStyle({
                  'border-color': _ctx.searchQuery ? '#8b5cf6' : '#e5e7eb',
                  'background-color': '#ffffff',
                  'color': '#111827',
                  'box-shadow': '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
                }),
                onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSearchFocus && _ctx.handleSearchFocus(...args))),
                onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSearchBlur && _ctx.handleSearchBlur(...args)))
              }, null, 44, _hoisted_7), [
                [_vModelText, _ctx.searchQuery]
              ]),
              (_ctx.searchQuery)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer transition-all duration-200 hover:scale-110",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.searchQuery = ''))
                  }, [
                    _createElementVNode("div", {
                      class: "w-7 h-7 rounded-full flex items-center justify-center transition-colors duration-200",
                      style: {"background-color":"rgba(139, 92, 246, 0.1)"},
                      onMouseover: _cache[3] || (_cache[3] = ($event: any) => ($event.currentTarget.style.backgroundColor = 'rgba(139, 92, 246, 0.2)')),
                      onMouseleave: _cache[4] || (_cache[4] = ($event: any) => ($event.currentTarget.style.backgroundColor = 'rgba(139, 92, 246, 0.1)'))
                    }, _cache[41] || (_cache[41] = [
                      _createElementVNode("i", {
                        class: "material-symbols-outlined !text-[18px]",
                        style: {"color":"#8b5cf6"}
                      }, "close", -1)
                    ]), 32)
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "group flex items-center gap-2 px-4 sm:px-6 py-3 rounded-full font-medium text-sm sm:text-base transition-all duration-300 transform hover:scale-105 hover:shadow-xl shadow-lg",
            style: {"background":"linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)","color":"#ffffff"},
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.openTaskModal(null)))
          }, [
            _cache[42] || (_cache[42] = _createElementVNode("div", {
              class: "w-8 h-8 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:rotate-180",
              style: {"background-color":"rgba(255, 255, 255, 0.2)"}
            }, [
              _createElementVNode("i", {
                class: "material-symbols-outlined !text-[20px]",
                style: {"color":"#ffffff"}
              }, " add ")
            ], -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.directT('todoList.addNewTask')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.directT('todoList.todayTasks') || 'משימות להיום'), 1),
              _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.todayTasksCount), 1)
            ]),
            _cache[43] || (_cache[43] = _createElementVNode("div", {
              class: "w-12 h-12 rounded-full flex items-center justify-center",
              style: {"background-color":"rgba(255, 255, 255, 0.2)"}
            }, [
              _createElementVNode("i", { class: "material-symbols-outlined !text-[24px] text-white" }, "today")
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.directT('todoList.weekTasks') || 'משימות השבוע'), 1),
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.weekTasksCount), 1)
            ]),
            _cache[44] || (_cache[44] = _createElementVNode("div", {
              class: "w-12 h-12 rounded-full flex items-center justify-center",
              style: {"background-color":"rgba(255, 255, 255, 0.2)"}
            }, [
              _createElementVNode("i", { class: "material-symbols-outlined !text-[24px] text-white" }, "date_range")
            ], -1))
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.directT('todoList.priorityBreakdown') || 'פילוח לפי דחיפות'), 1),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[45] || (_cache[45] = _createElementVNode("div", {
                    class: "w-2 h-2 rounded-full",
                    style: {"background-color":"#ef4444"}
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.directT('todoList.high')), 1)
                ]),
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.priorityCount.high), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _cache[46] || (_cache[46] = _createElementVNode("div", {
                    class: "w-2 h-2 rounded-full",
                    style: {"background-color":"#f59e0b"}
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.directT('todoList.medium')), 1)
                ]),
                _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.priorityCount.medium), 1)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _cache[47] || (_cache[47] = _createElementVNode("div", {
                    class: "w-2 h-2 rounded-full",
                    style: {"background-color":"#10b981"}
                  }, null, -1)),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.directT('todoList.low')), 1)
                ]),
                _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.priorityCount.low), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("div", _hoisted_35, [
        _createElementVNode("div", _hoisted_36, [
          _createElementVNode("h3", _hoisted_37, [
            _cache[48] || (_cache[48] = _createElementVNode("i", {
              class: "material-symbols-outlined !text-[20px] align-middle mr-2",
              style: {"color":"#8b5cf6"}
            }, "filter_list", -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.filterTasks') || 'סינון משימות'), 1)
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", _hoisted_39, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateFilter) = $event)),
                class: "appearance-none px-4 py-2 pr-10 rounded-lg border-2 transition-all duration-200 text-sm font-medium cursor-pointer hover:shadow-md focus:shadow-lg outline-none",
                style: {"border-color":"#e5e7eb","background-color":"#f9fafb","color":"#374151"},
                onChange: _cache[8] || (_cache[8] = ($event: any) => ($event.target.style.borderColor = _ctx.dateFilter !== 'all' ? '#8b5cf6' : '#e5e7eb'))
              }, [
                _createElementVNode("option", _hoisted_40, _toDisplayString(_ctx.directT('todoList.allDates') || 'כל התאריכים'), 1),
                _createElementVNode("option", _hoisted_41, _toDisplayString(_ctx.directT('todoList.overdue') || 'באיחור'), 1),
                _createElementVNode("option", _hoisted_42, _toDisplayString(_ctx.directT('todoList.today') || 'היום'), 1),
                _createElementVNode("option", _hoisted_43, _toDisplayString(_ctx.directT('todoList.tomorrow') || 'מחר'), 1),
                _createElementVNode("option", _hoisted_44, _toDisplayString(_ctx.directT('todoList.thisWeek') || 'השבוע'), 1),
                _createElementVNode("option", _hoisted_45, _toDisplayString(_ctx.directT('todoList.nextWeek') || 'שבוע הבא'), 1),
                _createElementVNode("option", _hoisted_46, _toDisplayString(_ctx.directT('todoList.thisMonth') || 'החודש'), 1)
              ], 544), [
                [_vModelSelect, _ctx.dateFilter]
              ]),
              _cache[49] || (_cache[49] = _createElementVNode("i", {
                class: "material-symbols-outlined !text-[20px] absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none",
                style: {"color":"#6b7280"}
              }, "expand_more", -1))
            ]),
            _createElementVNode("div", _hoisted_47, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.priorityFilter) = $event)),
                class: "appearance-none px-4 py-2 pr-10 rounded-lg border-2 transition-all duration-200 text-sm font-medium cursor-pointer hover:shadow-md focus:shadow-lg outline-none",
                style: {"border-color":"#e5e7eb","background-color":"#f9fafb","color":"#374151"},
                onChange: _cache[10] || (_cache[10] = ($event: any) => ($event.target.style.borderColor = _ctx.priorityFilter !== 'all' ? '#8b5cf6' : '#e5e7eb'))
              }, [
                _createElementVNode("option", _hoisted_48, _toDisplayString(_ctx.directT('todoList.allPriorities') || 'כל הדחיפויות'), 1),
                _createElementVNode("option", _hoisted_49, "🔴 " + _toDisplayString(_ctx.directT('todoList.high')), 1),
                _createElementVNode("option", _hoisted_50, "🟡 " + _toDisplayString(_ctx.directT('todoList.medium')), 1),
                _createElementVNode("option", _hoisted_51, "🟢 " + _toDisplayString(_ctx.directT('todoList.low')), 1)
              ], 544), [
                [_vModelSelect, _ctx.priorityFilter]
              ]),
              _cache[50] || (_cache[50] = _createElementVNode("i", {
                class: "material-symbols-outlined !text-[20px] absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none",
                style: {"color":"#6b7280"}
              }, "expand_more", -1))
            ]),
            _createElementVNode("div", _hoisted_52, [
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.statusFilter) = $event)),
                class: "appearance-none px-4 py-2 pr-10 rounded-lg border-2 transition-all duration-200 text-sm font-medium cursor-pointer hover:shadow-md focus:shadow-lg outline-none",
                style: {"border-color":"#e5e7eb","background-color":"#f9fafb","color":"#374151"},
                onChange: _cache[12] || (_cache[12] = ($event: any) => ($event.target.style.borderColor = _ctx.statusFilter !== 'all' ? '#8b5cf6' : '#e5e7eb'))
              }, [
                _createElementVNode("option", _hoisted_53, _toDisplayString(_ctx.directT('todoList.allStatuses') || 'כל הסטטוסים'), 1),
                _createElementVNode("option", _hoisted_54, "⏳ " + _toDisplayString(_ctx.directT('todoList.pending')), 1),
                _createElementVNode("option", _hoisted_55, "🔄 " + _toDisplayString(_ctx.directT('todoList.inProgress')), 1),
                _createElementVNode("option", _hoisted_56, "✅ " + _toDisplayString(_ctx.directT('todoList.completed')), 1),
                _createElementVNode("option", _hoisted_57, "❌ " + _toDisplayString(_ctx.directT('todoList.cancelled')), 1)
              ], 544), [
                [_vModelSelect, _ctx.statusFilter]
              ]),
              _cache[51] || (_cache[51] = _createElementVNode("i", {
                class: "material-symbols-outlined !text-[20px] absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none",
                style: {"color":"#6b7280"}
              }, "expand_more", -1))
            ]),
            (_ctx.dateFilter !== 'all' || _ctx.priorityFilter !== 'all' || _ctx.statusFilter !== 'all')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args))),
                  class: "px-4 py-2 rounded-lg transition-all duration-200 text-sm font-medium hover:shadow-md",
                  style: {"background-color":"#fee2e2","color":"#dc2626"},
                  onMouseover: _cache[14] || (_cache[14] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#fecaca')),
                  onMouseleave: _cache[15] || (_cache[15] = ($event: any) => ($event.currentTarget.style.backgroundColor = '#fee2e2'))
                }, [
                  _cache[52] || (_cache[52] = _createElementVNode("i", { class: "material-symbols-outlined !text-[16px] align-middle mr-1" }, "clear", -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.clearFilters') || 'נקה סינון'), 1)
                ], 32))
              : _createCommentVNode("", true)
          ])
        ]),
        (_ctx.dateFilter !== 'all' || _ctx.priorityFilter !== 'all' || _ctx.statusFilter !== 'all')
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.directT('todoList.activeFilters') || 'סינון פעיל:'), 1),
              (_ctx.dateFilter !== 'all')
                ? (_openBlock(), _createElementBlock("span", _hoisted_60, [
                    _cache[53] || (_cache[53] = _createElementVNode("i", { class: "material-symbols-outlined !text-[14px]" }, "calendar_today", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getLocalizedDateFilter(_ctx.dateFilter)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.priorityFilter !== 'all')
                ? (_openBlock(), _createElementBlock("span", _hoisted_61, [
                    _cache[54] || (_cache[54] = _createElementVNode("i", { class: "material-symbols-outlined !text-[14px]" }, "priority_high", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getLocalizedPriority(_ctx.priorityFilter)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.statusFilter !== 'all')
                ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                    _cache[55] || (_cache[55] = _createElementVNode("i", { class: "material-symbols-outlined !text-[14px]" }, "flag", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.getLocalizedStatus(_ctx.statusFilter)), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_63, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _cache[56] || (_cache[56] = _createElementVNode("div", { class: "relative" }, [
              _createElementVNode("div", { class: "w-16 h-16 rounded-full border-4 animate-spin border-gray-200 border-t-primary-500 dark:border-[#172036] dark:border-t-primary-400" })
            ], -1)),
            _createElementVNode("p", _hoisted_65, _toDisplayString(_ctx.directT('todoList.loading')), 1)
          ]))
        : (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
              _cache[57] || (_cache[57] = _createElementVNode("div", { class: "inline-flex items-center justify-center w-16 h-16 rounded-full mb-4 bg-danger-50 dark:bg-danger-900/20" }, [
                _createElementVNode("i", { class: "material-symbols-outlined !text-[32px] text-danger-500" }, "error")
              ], -1)),
              _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.errorMessage), 1)
            ]))
          : (_ctx.filteredTasks.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _cache[58] || (_cache[58] = _createElementVNode("div", { class: "inline-flex items-center justify-center w-16 h-16 rounded-full mb-4 bg-gray-100 dark:bg-[#15203c]" }, [
                  _createElementVNode("i", { class: "material-symbols-outlined !text-[32px] text-gray-500 dark:text-gray-400" }, "task_alt")
                ], -1)),
                _createElementVNode("p", _hoisted_69, _toDisplayString(_ctx.directT('todoList.noTasksFound')), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_70, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTasks, (task) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: task.id,
                    class: "group relative overflow-hidden rounded-2xl transition-all duration-300 hover:shadow-2xl transform hover:-translate-y-1 shadow-lg bg-white dark:bg-[#15203c] border border-gray-100 dark:border-[#172036]"
                  }, [
                    _createElementVNode("div", _hoisted_71, [
                      _createElementVNode("div", _hoisted_72, [
                        _createElementVNode("div", _hoisted_73, [
                          _createElementVNode("div", _hoisted_74, [
                            _createElementVNode("h3", _hoisted_75, _toDisplayString(task.tasktitle), 1)
                          ]),
                          _createElementVNode("div", _hoisted_76, [
                            _createElementVNode("div", _hoisted_77, [
                              _cache[59] || (_cache[59] = _createElementVNode("i", { class: "material-symbols-outlined !text-[16px] sm:!text-[18px] text-gray-500 dark:text-gray-400" }, "person", -1)),
                              _createElementVNode("span", _hoisted_78, _toDisplayString(task.assignedName || _ctx.directT('todoList.notAssigned')), 1)
                            ]),
                            _createElementVNode("div", _hoisted_79, [
                              _cache[60] || (_cache[60] = _createElementVNode("i", { class: "material-symbols-outlined !text-[16px] sm:!text-[18px] text-gray-500 dark:text-gray-400" }, "calendar_today", -1)),
                              _createElementVNode("span", _hoisted_80, _toDisplayString(_ctx.formatDate(task.duedate)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_81, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["w-2 h-2 rounded-full flex-shrink-0", {
                        'bg-danger-500': task.priority === 'high',
                        'bg-warning-500': task.priority === 'medium',
                        'bg-success-500': task.priority === 'low'
                      }])
                              }, null, 2),
                              _createElementVNode("span", _hoisted_82, _toDisplayString(_ctx.getLocalizedPriority(task.priority || 'medium')), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_83, [
                            _createElementVNode("span", {
                              class: _normalizeClass(["inline-flex items-center px-2 sm:px-3 py-1 rounded-full text-xs font-medium", _ctx.getStatusClasses(task.status)])
                            }, _toDisplayString(_ctx.getLocalizedStatus(task.status)), 3)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_84, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg transition-all duration-200 hover:scale-110 text-white shadow-md hover:shadow-lg text-xs sm:text-sm font-medium",
                            style: {"background":"linear-gradient(135deg, #667eea 0%, #764ba2 100%)"},
                            onClick: ($event: any) => (_ctx.viewTask(task))
                          }, _toDisplayString(_ctx.directT('todoList.view')), 9, _hoisted_85),
                          _createElementVNode("button", {
                            type: "button",
                            class: "px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg transition-all duration-200 hover:scale-110 text-white shadow-md hover:shadow-lg text-xs sm:text-sm font-medium",
                            style: {"background":"linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"},
                            onClick: ($event: any) => (_ctx.openTaskModal(task))
                          }, _toDisplayString(_ctx.directT('todoList.edit')), 9, _hoisted_86),
                          _createElementVNode("button", {
                            type: "button",
                            class: "px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg transition-all duration-200 hover:scale-110 text-white shadow-md hover:shadow-lg text-xs sm:text-sm font-medium",
                            style: {"background":"linear-gradient(135deg, #fa709a 0%, #fee140 100%)"},
                            onClick: ($event: any) => (_ctx.deleteTask(task))
                          }, _toDisplayString(_ctx.directT('todoList.delete')), 9, _hoisted_87)
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ]))
    ]),
    (_ctx.showTaskModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_88, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black/40 backdrop-blur-sm",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.closeTaskModal && _ctx.closeTaskModal(...args)))
          }),
          _createElementVNode("div", _hoisted_89, [
            _createElementVNode("div", _hoisted_90, [
              _createElementVNode("div", _hoisted_91, [
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("i", _hoisted_95, _toDisplayString(_ctx.editingTask ? 'edit_note' : 'add_task'), 1)
                    ]),
                    _createElementVNode("h2", _hoisted_96, _toDisplayString(_ctx.editingTask ? _ctx.directT('todoList.editTask') : _ctx.directT('todoList.addTask')), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.closeTaskModal && _ctx.closeTaskModal(...args))),
                    class: "w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200 flex items-center justify-center group",
                    style: {"border":"none","cursor":"pointer"}
                  }, _cache[61] || (_cache[61] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-white group-hover:rotate-90 transition-transform duration-200" }, " close ", -1)
                  ]))
                ])
              ]),
              _createElementVNode("div", _hoisted_97, [
                _createElementVNode("div", _hoisted_98, [
                  _createElementVNode("label", _hoisted_99, [
                    _cache[62] || (_cache[62] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-primary-500" }, "title", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.taskTitle')), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.taskForm.tasktitle) = $event)),
                    placeholder: _ctx.directT('todoList.enterTaskTitle'),
                    class: "w-full px-4 py-3 rounded-xl border-2 border-gray-200 dark:border-gray-700 text-sm transition-all duration-200 focus:ring-4 focus:ring-primary-500/20 focus:border-primary-500 bg-gray-50 dark:bg-[#2c2c2e] text-black dark:text-white placeholder:text-gray-400"
                  }, null, 8, _hoisted_100), [
                    [_vModelText, _ctx.taskForm.tasktitle]
                  ])
                ]),
                _createElementVNode("div", _hoisted_101, [
                  _createElementVNode("label", _hoisted_102, [
                    _cache[63] || (_cache[63] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-primary-500" }, "event", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.dueDate')), 1)
                  ]),
                  _withDirectives(_createElementVNode("input", {
                    type: "datetime-local",
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.taskForm.duedate) = $event)),
                    class: "w-full px-4 py-3 rounded-xl border-2 border-gray-200 dark:border-gray-700 text-sm transition-all duration-200 focus:ring-4 focus:ring-primary-500/20 focus:border-primary-500 bg-gray-50 dark:bg-[#2c2c2e] text-black dark:text-white"
                  }, null, 512), [
                    [_vModelText, _ctx.taskForm.duedate]
                  ])
                ]),
                _createElementVNode("div", _hoisted_103, [
                  _createElementVNode("label", _hoisted_104, [
                    _cache[64] || (_cache[64] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-primary-500" }, "person", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.assignedTo')), 1)
                  ]),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.taskForm.assignedto) = $event)),
                    class: "w-full px-4 py-3 rounded-xl border-2 border-gray-200 dark:border-gray-700 text-sm transition-all duration-200 focus:ring-4 focus:ring-primary-500/20 focus:border-primary-500 bg-gray-50 dark:bg-[#2c2c2e] text-black dark:text-white"
                  }, [
                    _createElementVNode("option", _hoisted_105, _toDisplayString(_ctx.directT('todoList.notAssigned')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: user.id,
                        value: user.id
                      }, _toDisplayString(user.email), 9, _hoisted_106))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.taskForm.assignedto]
                  ])
                ]),
                _createElementVNode("div", _hoisted_107, [
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("label", _hoisted_109, [
                      _cache[65] || (_cache[65] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-primary-500" }, "priority_high", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.priority')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_110, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.taskForm.priority) = $event)),
                        class: "w-full px-4 py-3 rounded-xl border-2 border-gray-200 dark:border-gray-700 text-sm transition-all duration-200 focus:ring-4 focus:ring-primary-500/20 focus:border-primary-500 bg-gray-50 dark:bg-[#2c2c2e] text-black dark:text-white appearance-none"
                      }, [
                        _createElementVNode("option", _hoisted_111, "🔴 " + _toDisplayString(_ctx.directT('todoList.high')), 1),
                        _createElementVNode("option", _hoisted_112, "🟡 " + _toDisplayString(_ctx.directT('todoList.medium')), 1),
                        _createElementVNode("option", _hoisted_113, "🟢 " + _toDisplayString(_ctx.directT('todoList.low')), 1)
                      ], 512), [
                        [_vModelSelect, _ctx.taskForm.priority]
                      ]),
                      _cache[66] || (_cache[66] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400" }, " expand_more ", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("label", _hoisted_115, [
                      _cache[67] || (_cache[67] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-primary-500" }, "flag", -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.status')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_116, [
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.taskForm.status) = $event)),
                        class: "w-full px-4 py-3 rounded-xl border-2 border-gray-200 dark:border-gray-700 text-sm transition-all duration-200 focus:ring-4 focus:ring-primary-500/20 focus:border-primary-500 bg-gray-50 dark:bg-[#2c2c2e] text-black dark:text-white appearance-none"
                      }, [
                        _createElementVNode("option", _hoisted_117, "⏳ " + _toDisplayString(_ctx.directT('todoList.pending')), 1),
                        _createElementVNode("option", _hoisted_118, "🔄 " + _toDisplayString(_ctx.directT('todoList.inProgress')), 1),
                        _createElementVNode("option", _hoisted_119, "✅ " + _toDisplayString(_ctx.directT('todoList.completed')), 1),
                        _createElementVNode("option", _hoisted_120, "❌ " + _toDisplayString(_ctx.directT('todoList.cancelled')), 1)
                      ], 512), [
                        [_vModelSelect, _ctx.taskForm.status]
                      ]),
                      _cache[68] || (_cache[68] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400" }, " expand_more ", -1))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_121, [
                  _createElementVNode("label", _hoisted_122, [
                    _cache[69] || (_cache[69] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-primary-500" }, "description", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.description')) + " ", 1),
                    _createElementVNode("span", _hoisted_123, _toDisplayString(_ctx.taskForm.description?.length || 0) + "/500 ", 1)
                  ]),
                  _withDirectives(_createElementVNode("textarea", {
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.taskForm.description) = $event)),
                    rows: "4",
                    maxlength: "500",
                    placeholder: _ctx.directT('todoList.enterDescription'),
                    class: "w-full px-4 py-3 rounded-xl border-2 border-gray-200 dark:border-gray-700 text-sm transition-all duration-200 focus:ring-4 focus:ring-primary-500/20 focus:border-primary-500 resize-none bg-gray-50 dark:bg-[#2c2c2e] text-black dark:text-white placeholder:text-gray-400"
                  }, null, 8, _hoisted_124), [
                    [_vModelText, _ctx.taskForm.description]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_125, [
                _createElementVNode("button", {
                  onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.closeTaskModal && _ctx.closeTaskModal(...args))),
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 bg-white dark:bg-[#2c2c2e] text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-[#3c3c3e] border border-gray-200 dark:border-gray-700"
                }, _toDisplayString(_ctx.directT('todoList.cancel')), 1),
                _createElementVNode("button", {
                  onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.saveTask && _ctx.saveTask(...args))),
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 disabled:opacity-50 bg-gradient-to-r from-primary-500 to-primary-600 hover:from-primary-600 hover:to-primary-700 text-white shadow-lg shadow-primary-500/25 disabled:shadow-none",
                  disabled: _ctx.saveLoading || !_ctx.taskForm.tasktitle
                }, [
                  (_ctx.saveLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_127, [
                        _cache[70] || (_cache[70] = _createElementVNode("svg", {
                          class: "animate-spin h-4 w-4",
                          viewBox: "0 0 24 24"
                        }, [
                          _createElementVNode("circle", {
                            class: "opacity-25",
                            cx: "12",
                            cy: "12",
                            r: "10",
                            stroke: "currentColor",
                            "stroke-width": "4",
                            fill: "none"
                          }),
                          _createElementVNode("path", {
                            class: "opacity-75",
                            fill: "currentColor",
                            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.saving')), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_128, [
                        _createElementVNode("i", _hoisted_129, _toDisplayString(_ctx.editingTask ? 'save' : 'add'), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.editingTask ? _ctx.directT('todoList.save') : _ctx.directT('todoList.create')), 1)
                      ]))
                ], 8, _hoisted_126)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showViewModal && _ctx.viewingTask)
      ? (_openBlock(), _createElementBlock("div", _hoisted_130, [
          _createElementVNode("div", {
            class: "absolute inset-0 bg-black/40 backdrop-blur-sm",
            onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args)))
          }),
          _createElementVNode("div", _hoisted_131, [
            _createElementVNode("div", _hoisted_132, [
              _createElementVNode("div", {
                class: _normalizeClass(["relative px-6 py-5 flex-shrink-0", {
                 'bg-gradient-to-r from-warning-500 to-warning-600': _ctx.viewingTask.status === 'pending',
                 'bg-gradient-to-r from-info-500 to-info-600': _ctx.viewingTask.status === 'in_progress',
                 'bg-gradient-to-r from-success-500 to-success-600': _ctx.viewingTask.status === 'completed',
                 'bg-gradient-to-r from-danger-500 to-danger-600': _ctx.viewingTask.status === 'cancelled'
               }])
              }, [
                _createElementVNode("div", _hoisted_133, [
                  _createElementVNode("div", _hoisted_134, [
                    _cache[71] || (_cache[71] = _createElementVNode("div", { class: "w-10 h-10 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center" }, [
                      _createElementVNode("i", { class: "material-symbols-outlined !text-[24px] text-white" }, " task ")
                    ], -1)),
                    _createElementVNode("h2", _hoisted_135, _toDisplayString(_ctx.directT('todoList.taskDetails')), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                    class: "w-8 h-8 rounded-full bg-white/20 hover:bg-white/30 transition-all duration-200 flex items-center justify-center group",
                    style: {"border":"none","cursor":"pointer"}
                  }, _cache[72] || (_cache[72] = [
                    _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-white group-hover:rotate-90 transition-transform duration-200" }, " close ", -1)
                  ]))
                ])
              ], 2),
              _createElementVNode("div", _hoisted_136, [
                _createElementVNode("div", _hoisted_137, [
                  _createElementVNode("div", _hoisted_138, [
                    _cache[73] || (_cache[73] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-gray-400" }, "title", -1)),
                    _createElementVNode("span", _hoisted_139, _toDisplayString(_ctx.directT('todoList.title')), 1)
                  ]),
                  _createElementVNode("h3", _hoisted_140, _toDisplayString(_ctx.viewingTask.tasktitle), 1)
                ]),
                _createElementVNode("div", _hoisted_141, [
                  _createElementVNode("div", _hoisted_142, [
                    _createElementVNode("div", _hoisted_143, [
                      _cache[74] || (_cache[74] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-gray-400" }, "person", -1)),
                      _createElementVNode("span", _hoisted_144, _toDisplayString(_ctx.directT('todoList.assignedTo')), 1)
                    ]),
                    _createElementVNode("span", _hoisted_145, _toDisplayString(_ctx.viewingTask.assignedName || _ctx.directT('todoList.notAssigned')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_146, [
                    _createElementVNode("div", _hoisted_147, [
                      _cache[75] || (_cache[75] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-gray-400" }, "event", -1)),
                      _createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.directT('todoList.dueDate')), 1)
                    ]),
                    _createElementVNode("span", _hoisted_149, _toDisplayString(_ctx.formatDate(_ctx.viewingTask.duedate)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_150, [
                    _createElementVNode("div", _hoisted_151, [
                      _cache[76] || (_cache[76] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-gray-400" }, "priority_high", -1)),
                      _createElementVNode("span", _hoisted_152, _toDisplayString(_ctx.directT('todoList.priority')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_153, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["w-3 h-3 rounded-full", {
                      'bg-danger-500': _ctx.viewingTask.priority === 'high',
                      'bg-warning-500': _ctx.viewingTask.priority === 'medium',
                      'bg-success-500': _ctx.viewingTask.priority === 'low'
                    }])
                      }, null, 2),
                      _createElementVNode("span", _hoisted_154, _toDisplayString(_ctx.getLocalizedPriority(_ctx.viewingTask.priority || 'medium')), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_155, [
                    _createElementVNode("div", _hoisted_156, [
                      _cache[77] || (_cache[77] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px] text-gray-400" }, "flag", -1)),
                      _createElementVNode("span", _hoisted_157, _toDisplayString(_ctx.directT('todoList.status')), 1)
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["inline-flex items-center px-3 py-1.5 rounded-full text-xs font-bold", _ctx.getStatusClasses(_ctx.viewingTask.status)])
                    }, _toDisplayString(_ctx.getLocalizedStatus(_ctx.viewingTask.status)), 3)
                  ])
                ]),
                (_ctx.viewingTask.description)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_158, [
                      _createElementVNode("div", _hoisted_159, [
                        _cache[78] || (_cache[78] = _createElementVNode("i", { class: "material-symbols-outlined !text-[20px] text-gray-400" }, "description", -1)),
                        _createElementVNode("span", _hoisted_160, _toDisplayString(_ctx.directT('todoList.description')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_161, [
                        _createElementVNode("p", _hoisted_162, _toDisplayString(_ctx.viewingTask.description), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_163, [
                _createElementVNode("button", {
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.editFromViewModal(_ctx.viewingTask))),
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 bg-white dark:bg-[#2c2c2e] text-primary-500 hover:bg-primary-50 dark:hover:bg-primary-900/20 border border-primary-200 dark:border-primary-800"
                }, [
                  _createElementVNode("span", _hoisted_164, [
                    _cache[79] || (_cache[79] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, "edit", -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.edit')), 1)
                  ])
                ]),
                _createElementVNode("button", {
                  onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.closeViewModal && _ctx.closeViewModal(...args))),
                  class: "px-5 py-2.5 rounded-xl font-medium text-sm transition-all duration-200 bg-gray-200 dark:bg-[#2c2c2e] text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-[#3c3c3e]"
                }, _toDisplayString(_ctx.directT('todoList.close')), 1)
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showDeleteModal && _ctx.deletingTask)
      ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
          _createElementVNode("div", {
            class: "absolute inset-0",
            style: {"background-color":"rgba(0, 0, 0, 0.4)","backdrop-filter":"blur(4px)"},
            onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args)))
          }),
          _createElementVNode("div", _hoisted_166, [
            _createElementVNode("div", {
              style: _normalizeStyle([{"background-color":"#ffffff","border-radius":"24px","box-shadow":"0 25px 50px -12px rgba(0, 0, 0, 0.25)","overflow":"hidden"}, _ctx.isDarkMode ? 'background-color: #1c1c1e;' : ''])
            }, [
              _createElementVNode("div", _hoisted_167, [
                _createElementVNode("div", _hoisted_168, [
                  _createElementVNode("div", _hoisted_169, [
                    _cache[80] || (_cache[80] = _createElementVNode("div", { style: {"width":"40px","height":"40px","background-color":"rgba(255, 255, 255, 0.2)","backdrop-filter":"blur(4px)","border-radius":"16px","display":"flex","align-items":"center","justify-content":"center"} }, [
                      _createElementVNode("i", {
                        class: "material-symbols-outlined !text-[24px]",
                        style: {"color":"#ffffff"}
                      }, " delete_forever ")
                    ], -1)),
                    _createElementVNode("h2", _hoisted_170, _toDisplayString(_ctx.directT('todoList.deleteTask') || 'מחיקת משימה'), 1)
                  ]),
                  _createElementVNode("button", {
                    onClick: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                    style: {"width":"32px","height":"32px","background-color":"rgba(255, 255, 255, 0.2)","border-radius":"50%","transition":"all 0.2s","display":"flex","align-items":"center","justify-content":"center","border":"none","cursor":"pointer"},
                    onMouseover: _cache[32] || (_cache[32] = event => event.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.3)'),
                    onMouseout: _cache[33] || (_cache[33] = event => event.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.2)')
                  }, _cache[81] || (_cache[81] = [
                    _createElementVNode("i", {
                      class: "material-symbols-outlined !text-[20px]",
                      style: {"color":"#ffffff","transition":"transform 0.2s"}
                    }, " close ", -1)
                  ]), 32)
                ])
              ]),
              _createElementVNode("div", _hoisted_171, [
                _createElementVNode("div", {
                  style: _normalizeStyle([{"width":"64px","height":"64px","background-color":"#fee2e2","border-radius":"50%","display":"flex","align-items":"center","justify-content":"center","margin":"0 auto 24px"}, _ctx.isDarkMode ? 'background-color: rgba(239, 68, 68, 0.2);' : ''])
                }, _cache[82] || (_cache[82] = [
                  _createElementVNode("i", {
                    class: "material-symbols-outlined !text-[32px]",
                    style: {"color":"#ef4444"}
                  }, " warning ", -1)
                ]), 4),
                _createElementVNode("div", _hoisted_172, [
                  _createElementVNode("p", {
                    style: _normalizeStyle([{"font-size":"18px","font-weight":"600","color":"#111827","margin-bottom":"8px"}, _ctx.isDarkMode ? 'color: #ffffff;' : ''])
                  }, _toDisplayString((_ctx.directT('todoList.deleteConfirmation') || 'האם אתה בטוח שברצונך למחוק את המשימה?').replace('{task}', _ctx.deletingTask.tasktitle)), 5),
                  _createElementVNode("p", {
                    style: _normalizeStyle([{"font-size":"14px","color":"#6b7280"}, _ctx.isDarkMode ? 'color: #9ca3af;' : ''])
                  }, _toDisplayString(_ctx.directT('todoList.deleteWarning') || 'פעולה זו אינה ניתנת לביטול'), 5)
                ])
              ]),
              _createElementVNode("div", {
                style: _normalizeStyle([{"padding":"24px","background-color":"#f9fafb","border-top":"1px solid #e5e7eb","display":"flex","justify-content":"space-between","gap":"12px"}, _ctx.isDarkMode ? 'background-color: #15203c; border-color: #374151;' : ''])
              }, [
                _createElementVNode("button", {
                  onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.closeDeleteModal && _ctx.closeDeleteModal(...args))),
                  style: _normalizeStyle([{"padding":"10px 20px","border-radius":"12px","font-weight":"500","font-size":"14px","transition":"all 0.2s","background-color":"#e5e7eb","color":"#374151"}, _ctx.isDarkMode ? 'background-color: #2c2c2e; color: #d1d5db;' : '']),
                  onMouseover: _cache[35] || (_cache[35] = event => event.currentTarget.style.backgroundColor = _ctx.isDarkMode ? '#3c3c3e' : '#d1d5db'),
                  onMouseout: _cache[36] || (_cache[36] = event => event.currentTarget.style.backgroundColor = _ctx.isDarkMode ? '#2c2c2e' : '#e5e7eb')
                }, _toDisplayString(_ctx.directT('todoList.cancel') || 'ביטול'), 37),
                _createElementVNode("button", {
                  onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args))),
                  disabled: _ctx.deleteLoading,
                  style: _normalizeStyle([{"padding":"10px 20px","border-radius":"12px","font-weight":"500","font-size":"14px","transition":"all 0.2s","background-color":"#ef4444","color":"#ffffff","display":"flex","align-items":"center","gap":"8px"}, _ctx.deleteLoading ? 'opacity: 0.6; cursor: not-allowed;' : '']),
                  onMouseover: _cache[38] || (_cache[38] = event => { if (!_ctx.deleteLoading) event.currentTarget.style.backgroundColor = '#dc2626' }),
                  onMouseout: _cache[39] || (_cache[39] = event => { if (!_ctx.deleteLoading) event.currentTarget.style.backgroundColor = '#ef4444' })
                }, [
                  (_ctx.deleteLoading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_174))
                    : (_openBlock(), _createElementBlock("span", _hoisted_175, [
                        _cache[83] || (_cache[83] = _createElementVNode("i", { class: "material-symbols-outlined !text-[18px]" }, "delete", -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.directT('todoList.delete') || 'מחיקה'), 1)
                      ]))
                ], 44, _hoisted_173)
              ], 4)
            ], 4)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}